import React, { useEffect, useRef } from "react";

import { WINNER_SSP, useAuctionOutcome } from "../../utils/adAuction";
import { insertDisplayCode } from "../../utils/displayCode";

/**
 * smi-блок floorad в аукционе: рисует displayCode ставки нашего RTB по этому блоку,
 * если она выиграла аукцион у «Моё видео».
 *
 * Контейнер без своего позиционирования и размеров: floor-виджет smi.js сам встаёт
 * вниз экрана, сам закрывается (delay/duration/auto_close заданы в SSP). Одиночного
 * режима нет — запись без `auction` сервер не отдаёт, а если она пришла, ничего не
 * рисуется.
 */
export function SspAdapter({ entry }) {
    const outcome = useAuctionOutcome(entry.auction);
    const container = useRef(null);
    const inserted = useRef(false);
    const bid = outcome && outcome.winner === WINNER_SSP ? outcome.bid : null;

    useEffect(() => {
        if (!bid || !container.current || inserted.current) {
            return;
        }

        inserted.current = true;
        insertDisplayCode(container.current, bid.displayCode);
    }, [bid]);

    if (!entry.auction || !bid) {
        return null;
    }

    return <div ref={container} />;
}

export default SspAdapter;
